import { render, staticRenderFns } from "./DesignerSelect.vue?vue&type=template&id=53d7276b&scoped=true"
import script from "./DesignerSelect.vue?vue&type=script&lang=js"
export * from "./DesignerSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d7276b",
  null
  
)

export default component.exports